export class Row<T> {
    status: string = 'new'; //'new','changed','loaded'
    hasError: boolean = false;
    object: T;
}


// WEBPACK FOOTER //
// ./src/app/models/tables/row.ts